import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	TEAM_CF_TYPE,
	ISSUE_FIELD_ANY_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggTeamToLegacyField: FieldTransformer<typeof TEAM_CF_TYPE> = (node) => {
	if (node.type !== TEAM_CF_TYPE) return undefined;

	const value = node.selectedTeam
		? {
				id: node.selectedTeam.teamId,
				title: node.selectedTeam.name,
				isShared: node.selectedTeam.isShared,
				avatarUrl: node.selectedTeam.avatar?.medium,
			}
		: null;

	return {
		...transformAggNodeToLegacyField(node),
		value,
		schema: {
			configuration: null,
			custom: TEAM_CF_TYPE,
			items: null,
			renderer: PLAIN_TEXT,
			system: null,
			type: ISSUE_FIELD_ANY_CF_TYPE,
		},
	};
};
